module.exports = __webpack_public_path__ + "static/elacaieurope-0f0e31709b711c3c760ef336f7cadb2c.jpg";